<template>
  <TsDrawer
      v-if="isMobile"
    :position="isMobile && 'bottom'"
    :dataTestid="props.dataTestid + '-main-wrapper'"
  >
    <template #[contentSlotName]>
      <TsCard dataTestid="proCardTermsModal" appendClass="bg-white p-4">
        <TsTypography
          :variant="!isMobile ? 'h4' : 'h5'"
          weight="semibold"
          appendClass="text-natural-black mb-6"
          >{{useTranslation('proCard-terms&conditions' ,'Voordat we aan de slag gaan, moet u de Algemene voorwaarden van de PRO Card lezen en accepteren')}}
        </TsTypography>

        <TsSection
          :append-class="
            twJoin(
              'h-full overflow-y-auto mb-1 p-0',
              isMobile ? 'max-h-96' : 'max-h-[84dvh]'
            )
          "
        >
        <template v-for="items in props.type === ProCardApplicationType.WITH_CREDIT
              ? withCreditTerms
              : withoutCreditTerms">
          <TsTypography
            :text="items.text"
          />
        </template>
          <TsRow append-class="justify-center items-center">
            <TsButton @click="handleAcceptTerms"
              >{{useTranslation("acceptTerms&Conditions" , "Ik accepteer de algemene voorwaarden")}}</TsButton
            >
          </TsRow>
        </TsSection>
      </TsCard>
    </template>
  </TsDrawer>
  <TsModal
      v-else
    :position="isMobile && 'bottom'"
    :dataTestid="props.dataTestid + '-main-wrapper'"
  >
    <template #[contentSlotName]>
      <TsCard dataTestid="proCardTermsModal" appendClass="bg-white p-4">
        <TsTypography
          :variant="!isMobile ? 'h4' : 'h5'"
          weight="semibold"
          appendClass="text-natural-black mb-6"
          >{{useTranslation('proCard-terms&conditions' ,'Voordat we aan de slag gaan, moet u de Algemene voorwaarden van de PRO Card lezen en accepteren')}}
        </TsTypography>

        <TsSection
          :append-class="
            twJoin(
              'h-full overflow-y-auto mb-1 p-0',
              isMobile ? 'max-h-96' : 'max-h-[84dvh]'
            )
          "
        >
        <template v-for="items in props.type === ProCardApplicationType.WITH_CREDIT
              ? withCreditTerms
              : withoutCreditTerms">
          <TsTypography
            :text="items.text"
          />
        </template>

          <TsRow append-class="justify-center items-center">
            <TsButton @click="handleAcceptTerms" data-testid="proCard-modal-terms-accept-button"
              >{{useTranslation("acceptTerms&Conditions" , "Ik accepteer de algemene voorwaarden")}}</TsButton
            >
          </TsRow>
        </TsSection>
      </TsCard>
    </template>
  </TsModal>
</template>

<script setup lang="ts">
import { twJoin } from "tailwind-merge";
import { ProCardApplicationType } from "~/types/ecom/procard.type";
const proCardStore = useProCardStore();

type Props = {
  type: ProCardApplicationType;
  dataTestid?: string;
};

const props = defineProps<Props>();
const emit = defineEmits<{
  accept: any;
}>();

const { builderApiKey } = useRuntimeConfig().public;
const i18n = useNuxtApp().$i18n.defaultLocale;

// onMounted(async () => {
//   const data = await import("../../json/pro_card_application_consent.json");
// });

proCardStore.getProCardTermsAndCondition(builderApiKey, { locale: i18n });

const getTermsContent = (key: string): string[] => proCardStore.procard_consent_data?.find((item) => item?.name === key)?.data?.content

const withCreditTerms = computed(() => getTermsContent('withCreditTerms'));
const withoutCreditTerms = computed(() => getTermsContent('withoutCreditTerms'))

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsDrawer = defineAsyncComponent(
    () => import('~/components/organisms/TsDrawer.vue')
);

const { isMobile } = useDevice();

const contentSlotName = computed<string>(() =>
  isMobile ? "default" : "modal-content"
);

function handleAcceptTerms() {
  emit("accept");
}
</script>

